<template lang="html">
  <div class="login-page-wrapper">
  <div class="middle-box text-center loginscreen  animated fadeInDown login">
    <div>
      <h3>会员登录</h3>
        <div class="form-group">
            <input type="text" class="form-control" v-model="phone" placeholder="手机号" required="">
        </div>
        <div class="form-group">
            <input type="password" v-model="psw" class="form-control" placeholder="密码" required="">
        </div>
        <button type="submit" class="btn btn-primary block full-width m-b" id="btn">登 录</button>
        <section style="display:flex;justify-content: space-between;">
          <p class="text-link text-center cursor">  <a @click="$router.push('/register')">快速注册</a></p>
        <p class="text-link text-center cursor">  <a @click="$router.push('/forget')">找回密码</a></p>
        </section>
        
      </div>
    </div>
    <alert-model v-bind:show="alertShow" v-on:close="catchClose" v-bind:msg="tips"></alert-model>
  </div>
</template>

<script>
import alertModel from './alert.vue'
import { encryptPassword } from '@/utils/passwordEncrypt'
export default {
  components: {
    alertModel
  },
  data() {
    return {
      phone: '',
      psw: '',
      capt: '',
      alertShow: false,
      tips: '',
      publicKey: null
    }
  },
  methods: {
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      if (typeof func === 'function') {
        func()
      }
    },
    login() {
      if (this.phone && this.psw) {
        let passwordToSend = this.psw
        if (this.publicKey) {
          const encrypted = encryptPassword(this.psw, this.publicKey)
          if (encrypted) {
            passwordToSend = encrypted
          }
        }
        let params = {
          mobile: this.phone,
          password: passwordToSend,
        }
        Object.assign(params, this.capt)
        this.$axios.post('/api/wenlian/login', this.qs.stringify(params)).then(res => {
          if (res.data.result == 1) {
            this.$store.commit('user', res.data.userinfo)
            if (res.data.userinfo.role == 3) {
              this.$router.push('/')
            } else {
              this.$router.push('/dataTypein')
            }
          } else {
            this.alert(res.data.msg)
          }
        })
      }
      // this.$router.push('/')
    }

  },
  mounted() {
    let _this = this
    this.$axios.get('/api/wenlian/getPublicKey').then(res => {
      const key = res.data && (res.data.publicKey || res.data.public_key)
      if (key) {
        this.publicKey = key
      }
    }).catch(() => {})
    this.$axios.get('/api/wenlian/startcaptcha').then(res => {
      this.session = res.data.sessionid
      console.log(!(!!res.data.success), !!res.data.new_captcha)
      initGeetest({
        // 以下配置参数来自服务端 SDK
        gt: res.data.gt,
        challenge: res.data.challenge,
        offline: !(!!res.data.success),
        new_captcha: !!res.data.new_captcha,
        product: 'bind'
      }, function (captchaObj) {
        captchaObj.onReady(function () {
          //验证码ready之后才能调用verify方法显示验证码
        }).onSuccess(function () {
          //your code
          _this.capt = captchaObj.getValidate()
          _this.login()
        }).onError(function () {
          //your code
        })
        $('#btn').click(function () {
          captchaObj.verify();
        })
        // 这里可以调用验证实例 captchaObj 的实例方法
      })
    })
  }
}

</script>

<style lang="css" scoped>
.login-page-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, #e8f5f3 0%, #f0f7f8 35%, #f5f7fa 70%, #eef4f3 100%);
}
.login-page-wrapper::before {
  content: '';
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(ellipse 80% 50% at 20% 20%, rgba(24, 166, 137, 0.12) 0%, transparent 50%),
    radial-gradient(ellipse 60% 40% at 80% 80%, rgba(26, 179, 148, 0.08) 0%, transparent 50%),
    radial-gradient(ellipse 100% 100% at 50% 50%, rgba(255, 255, 255, 0.5) 0%, transparent 70%);
  pointer-events: none;
}
.login-page-wrapper::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  opacity: 0.035;
  pointer-events: none;
}
.login-page-wrapper > .middle-box {
  position: relative;
  z-index: 1;
}
</style>

<style lang="css">
.middle-box h3 {
  margin-bottom: 30px;
  color: #999;
}
.loginscreen {
  width: 100vh;
  height: 100vh;
}
.text-link {
  color: #337ab7;
  font-size: 15px;
}
.middle-box {
  max-width: 400px;
  z-index: 100;
  margin: 0 auto;
  padding-top: 200px;
}
.login.loginscreen.middle-box {
  width: 300px;
}
.login .btn-primary {
  background-color: #1ab394;
  border-color: #1ab394;
  color: #fff;
}
.m-b {
  margin-bottom: 15px;
}
.full-width {
  width: 100% !important;
}
.login .text-muted {
  color: #888;
}
.login .text-muted {
  color: #777;
}
.login .form-control,
.single-line {
  background-color: #fff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  padding: 6px 12px;
  -webkit-transition: border-color 0.15s ease-in-out 0s,
    box-shadow 0.15s ease-in-out 0s;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  width: 100%;
  font-size: 14px;
}
.login .btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  opacity: 0.5;
  background-color: #18a689;
  border-color: #18a689;
}
.login .btn-primary {
  background-color: #18a689;
  border-color: #18a689;
  width: 200px;
}
.login .btn-primary:hover {
  background-color: #1ab394;
  border-color: #1ab394;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue